module.exports = __webpack_public_path__ + "assets/img/yutari-photo01.c39215c2.jpg";